<template>
  <div class="vue-select-utility-dropdown-wrap">
    <div v-if="utilitesForDropdown">
        <select @change="onUtilitySelectChange($event)" name="utilites">
          <option v-for="utility in utilitesForDropdown" v-bind:selected="utility.selected" :key="utility.utilityId" :value="utility.utilityId">{{utility.name}}</option>
        </select>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash';
const placeholderUtilityId = 999;

export default {
  name: 'SelectUtilityDropdown',
  props: {
    utilites: Array,
    utilitySelected: Function
  },
  data() {
    return {
      utilitesForDropdown: undefined,
      placeholderUtility: {
        utilityId: placeholderUtilityId,
        name: 'Please select a utility',
        selected: true
      }
    }
  },
  async created() {
    this.processUtilitesForDropdown(this.utilites);
  },
  watch: {
    utilites: function (utilites) {this.processUtilitesForDropdown(utilites); }
  },
  methods: {
    onUtilitySelectChange(event) {
      const utilityId = parseInt(event.target.value, 10);
      const matchingUtility = lodash.find(this.utilitesForDropdown, utility => utility.utilityId === utilityId);
      if (matchingUtility.utilityId === placeholderUtilityId) {return; }
      this.utilitySelected(matchingUtility);
    },
    processUtilitesForDropdown(utilites) {
      this.utilitesForDropdown = [this.placeholderUtility];
      setTimeout(() => {
        this.utilitesForDropdown = JSON.parse(JSON.stringify(utilites));
        this.utilitesForDropdown.unshift(this.placeholderUtility);
      }, 5);
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
